import React from 'react'
import { Heading } from '../HeadingModule/Heading'
import '../../styles/ArticleCarouselModule/ArticleCarouselHeading.scss'

export interface ArticleCarouselHeadingProps {
  heading: string
  fallback: string
}

export const ArticleCarouselHeading = ({ heading, fallback }: ArticleCarouselHeadingProps) => {
  return (
    <Heading
      text={heading || fallback}
      as="h2"
      className="article-carousel-heading"
      id="article-carousel-heading"
    />
  )
}
